import React from 'react'
import lang from '@/lang'
import orgamax from 'ampersand-app'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import config from '@/config'
import Info from '@/modules/base/components/info/info'
import { formatCurrency } from '@/modules/_helpers/formatCurrency'
import Badge from '@/modules/base/components/badge/badge'
import InfoItem from '@/modules/base/components/info/info-item'
import moment from 'moment'
import { getReceiptState, getReceiptStateColor } from '@/modules/receipt/_helpers/receiptState'
import { useNavigate } from 'react-router'

const EMPTY_PROP = '–'

const rowCount = {
  single: 1,
  multi: 3,
}

const RevenueInfo = (props) => {
  const { transaction, variant } = props
  const navigate = useNavigate()
  const classes = useStyles({ variant, priceTotal: transaction?.priceTotal })

  const stateInfo = {
    label: getReceiptState(transaction.state),
    color: getReceiptStateColor(transaction.state),
  }

  const infoItems = [
    { label: lang.payments.paymentDrawer.revenue.number, value: transaction?.receiptNumber || EMPTY_PROP },
    { label: lang.payments.paymentDrawer.revenue.date, value: transaction?.date ? moment(transaction?.date).format(config.dateFormat.client) : EMPTY_PROP },
  ]

  const onCustomerClick = () => {
    const { customerId, supplierId } = transaction
    if (customerId) navigate(`/customer/${customerId}`)
    else navigate(`/supplier/${supplierId}`)
  }

  return (
    <>
      <div>
        <div className={classes.badgeContainer}>
          <Badge label={stateInfo.label} color={stateInfo.color} customClass={classes.badge} customClassLabel={classes.badgeLabel} />
        </div>
        <div className={classes.priceRow}>
          <InfoItem infoItem={{ label: lang.payments.paymentDrawer.total, value: formatCurrency(transaction?.priceTotal) }} classNameValue={classes.price} />
          {transaction?.priceTotal !== transaction?.outstandingAmount
            && <InfoItem infoItem={{ label: lang.payments.paymentDrawer.openAmount, value: formatCurrency(transaction?.outstandingAmount) }} classNameValue={classes.price} />
          }
        </div>
        <div className={classes.customerName} onClick={onCustomerClick}>{transaction?.payee || ''}</div>
      </div>
      <div className={classes.line} />
      <Info infoItems={infoItems} className={classes.infoWrapper} classNameContainer={classes.infoContainer} rowCount={rowCount[variant]} />
      <div className={classes.line} />
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  priceRow: ({ variant }) => ({
    display: 'flex',
    flexDirection: variant === 'single' ? 'column' : 'row',
    paddingTop: 20,
    justifyContent: 'space-between',
    ...(variant === 'single' && {
      width: 'fit-content',
      gap: '20px',
    }),
  }),
  price: {
    color: theme.black,
    fontSize: '28px',
    letterSpacing: 0.56,
  },
  customerName: {
    color: theme.primary,
    fontSize: theme.fontSizes.smedium,
    paddingTop: 20,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  line: {
    width: '100%',
    height: '1px',
    margin: '20px 0px',
    backgroundColor: theme.borderColor,
  },
  infoWrapper: {
    padding: '0 !important',
  },
  infoContainer: {
    gap: 20,
  },
  badge: {
    width: 'fit-content',
  },
  badgeLabel: {
    padding: '0px 10px',
  },
  badgeContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
}))

RevenueInfo.propTypes = {
  variant: PropTypes.oneOf(['single', 'multi']),
  transaction: PropTypes.object,
}

RevenueInfo.defaultProps = {
  variant: 'multi',
}

export default RevenueInfo
